import axios from 'axios';
import { BaseV1ApiService } from '@/services/backend/baseV1';
import FileDownload from 'js-file-download';

export class DocumentsApiService extends BaseV1ApiService {
    constructor() {
        super('documents');
    }

    async downloadWithSignatures(documentId, filename) {
        try {
            const response = await axios.get(this.getUrl(`${documentId}/with_signatures`), { responseType: 'blob' });
            FileDownload(response.data, filename);
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }
}
